import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initial-state";
import { createReferral } from "./thunks/create-referral";
import { getOriginationUrl } from "./thunks/get-origination-url";
import { getReferralCode } from "./thunks/get-referral-code";
import { listReferrals } from "./thunks/list-referrals";

const name = "referrals";

export const slice = createSlice({
  name,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(listReferrals.pending, (state) => {
        state.isPending = true;
        state.isRejected = false;
        state.errorMessage = "";
      })
      .addCase(listReferrals.fulfilled, (state, action) => {
        state.referrals = action.payload;
        state.isPending = false;
        state.isRejected = false;
      })
      .addCase(listReferrals.rejected, (state, action) => {
        state.isPending = false;
        state.isRejected = true;
        state.errorMessage = action.error.message ?? "";
      })
      .addCase(createReferral.pending, (state) => {
        state.isCreating = true;
        state.createError = "";
      })
      .addCase(createReferral.fulfilled, (state, action) => {
        // Prepend the new lead (the list is newest first).
        state.referrals = [action.payload, ...state.referrals];
        state.isCreating = false;
      })
      .addCase(createReferral.rejected, (state, action) => {
        state.isCreating = false;
        state.createError = action.error.message ?? "";
      })
      .addCase(getOriginationUrl.fulfilled, (state, action) => {
        state.originationUrl = action.payload;
      })
      .addCase(getReferralCode.fulfilled, (state, action) => {
        state.referralCode = action.payload;
      });
  },
});

export const actions = slice.actions;
export const reducer = slice.reducer;
